import { publicGet } from '../../../api';
import { endpoints } from '../../../api/domains/endpoints';

function withQuery(url, params = {}) {
    const query = new URLSearchParams(
        Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== ''),
    ).toString();
    return query ? `${url}?${query}` : url;
}

export function getWhatshotPublishersAPI({ token, traceId }) {
    return publicGet(endpoints().whatsHot, { token, traceId });
}

export function getDiscoverPublishersAPI({ token, traceId, page, limit, search }) {
    return publicGet(withQuery(endpoints().discoverPublishers, { page, limit, search }), { token, traceId });
}

export function getFeaturedPublishersAPI({ token, traceId, page }) {
    return publicGet(withQuery(endpoints().featuredPublishers, { page }), { token, traceId });
}

export function getNearMePublishersAPI({ token, traceId, timezone }) {
    return publicGet(withQuery(endpoints().nearMe, { timezone }), { token, traceId });
}

export function getTrendingNearMePublishersAPI({ token, traceId, timezone }) {
    return publicGet(withQuery(endpoints().trendingNearMe, { timezone }), { token, traceId });
}

export function getRecommendationsAPI({ token, traceId, timezone }) {
    return publicGet(withQuery(endpoints().recommendations, { timezone }), { token, traceId });
}

export function getTotalSubscribersAPI({ token, traceId }) {
    return publicGet(endpoints().totalSubscribers, { token, traceId });
}
